export const FAILED_IMAGE_ATTRIBUTE = "data-image-load-failed";

const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";

const isHtmlImageElement = (element) =>
  element?.nodeType === 1 &&
  element.namespaceURI === HTML_NAMESPACE &&
  element.localName === "img" &&
  typeof element.setAttribute === "function" &&
  typeof element.removeAttribute === "function";

export const installImageFailureHandling = (eventTarget) => {
  if (
    typeof eventTarget?.addEventListener !== "function" ||
    typeof eventTarget?.removeEventListener !== "function"
  ) {
    throw new TypeError("An event target is required to install image failure handling.");
  }

  const hideFailedImage = (event) => {
    if (isHtmlImageElement(event.target)) {
      event.target.setAttribute(FAILED_IMAGE_ATTRIBUTE, "");
    }
  };

  const restoreLoadedImage = (event) => {
    if (isHtmlImageElement(event.target)) {
      event.target.removeAttribute(FAILED_IMAGE_ATTRIBUTE);
    }
  };

  eventTarget.addEventListener("error", hideFailedImage, true);
  eventTarget.addEventListener("load", restoreLoadedImage, true);

  let installed = true;

  return () => {
    if (!installed) return;

    eventTarget.removeEventListener("error", hideFailedImage, true);
    eventTarget.removeEventListener("load", restoreLoadedImage, true);
    installed = false;
  };
};
